/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';


export const GET_APPLICATION_COUNT = gql`
query Query(
  $totalApp: GetAppCountInput
  $wp:GetAppCountInput
  $csme:GetAppCountInput
  $csmev:GetAppCountInput
  $roe:GetAppCountInput
  $mec:GetAppCountInput
  $exem:GetAppCountInput
  $waiver:GetAppCountInput
  $cred:GetCredentialCountInput
) {
  cred: getCredentialCount(input: $cred)
  csme: getApplicationCount(input: $csme)
  csmev: getApplicationCount(input: $csmev)
  roe: getApplicationCount(input: $roe)
  mec: getApplicationCount(input: $mec)
  wp:getApplicationCount(input: $wp)
  waiver:getApplicationCount(input: $waiver)
  exem:getApplicationCount(input: $exem)
  totalApp: getApplicationCount(input: $totalApp)
}
`;
